export default "__VITE_ASSET__Wx_6G55B__"